import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";

class VolumeSelect extends Action {
    until;
    model;
    defaultAction;
    timelineMap;
    _stopper;

    constructor(props) {
        super(props);
        this.until = props.until;
        this.model = props.model;
        this.defaultAction = props.defaultAction && new LoadTimeline(props.defaultAction);
        this.pickAction = Object.fromEntries(props.timelineMap.map(item => [item.volume.id, new LoadTimeline(item)]));
        this._stopper = () => {
        };
    }

    async execute(eventLoop) {
        let self = this;
        this._stopper = activateVolumeSelect();
        setTimeout(this._stopper, self.until - self.startTime);

        function activateVolumeSelect() {
            VR.canvas.addEventListener('volume_selected', handleVolumeSelected);
            return () => VR.canvas.removeEventListener('volume_selected', handleVolumeSelected);
        }

        async function handleVolumeSelected(event) {
            const volumeObject = event.detail.volumeObject;
            const modelId = volumeObject?.volume?.modelId;
            const nextAction = getNextTimeline(modelId, volumeObject?.volume?.branchID);

            if (nextAction) {
                self._stopper();
                await nextAction.execute(eventLoop);
            }
        }

        function getNextTimeline(modelId, branchId) {
            if (!self.model || eventLoop.training.resources[self.model.id]?.resourceId === modelId ||
                (eventLoop.training.resources[self.model.id]?.type === ResourceTypeEnum.HELPER_OBJECT && eventLoop.training.resources[self.model.id]?.id === modelId)) {
                if (self.pickAction[branchId]) {
                    return self.pickAction[branchId];
                }

                if (self.defaultAction && self.defaultAction.timelines.length) {
                    return self.defaultAction;
                }

            }
        }
    }

    async stop() {
        this._stopper();
    }
}

export default VolumeSelect;